import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const root = css`
  text-align: center;
`;

export const label = (theme: Theme) => css`
  margin-bottom: ${theme.spacing[4]};
`;

export const amount = (theme: Theme) => css`
  margin-bottom: ${theme.spacing[8]};
`;
